import React, { Fragment, useState } from "react";
import CommonSearchBar from "../common/CommonSearchBar";
import AgencyDashboardContactedCard from "./AgencyDashboardContactedCard";

const cardData = [{ isBookMarked: false }, { isBookMarked: true }];

export default function AgencyDashboardContacted() {
  const [values, setValues] = useState({
    searchStrRequirementsContacted: "",
  });

  /*===========================================
              handler
  ===========================================*/

  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnClickSearchButton = (e) => {
    e.preventDefault();
    // console.log(values.searchStrRequirementsContacted);
  };

  /*===========================================
              main
  ===========================================*/
  return (
    <>
      <h3 className="font-16-NunitoSans-600 mb-38 color-white-35 mobile-text-gradient-1">
        List of Requirements Contacted
      </h3>
      <CommonSearchBar
        name="searchStrRequirementsContacted"
        value={values.searchStrRequirementsContacted}
        onChange={handleOnChange}
        onClickSearchButton={handleOnClickSearchButton}
      />

      {cardData.map((data, index) => (
        <Fragment key={index}>
          <AgencyDashboardContactedCard cardData={data} />
        </Fragment>
      ))}
    </>
  );
}
